import chroma from 'chroma-js';

/**
 * Validates if a color string is valid
 * @param color - Color in hex, rgb, hsl, or any format supported by chroma-js
 * @returns True if color is valid, false otherwise
 * @example
 * isValidColor('#095ea6') // true
 * isValidColor('rgb(9, 94, 166)') // true
 * isValidColor('invalid') // false
 */
export const isValidColor = (color: string): boolean => {
  return chroma.valid(color);
};
